module.exports = __webpack_public_path__ + "static/media/b84367cc-6d47-4d4a-a484-158d123188ae.34ebfed7.JPG";